import { render } from "./EventsDate.vue?vue&type=template&id=9b1d0550&scoped=true&ts=true"
import script from "./EventsDate.vue?vue&type=script&lang=ts"
export * from "./EventsDate.vue?vue&type=script&lang=ts"

import "./EventsDate.vue?vue&type=style&index=0&id=9b1d0550&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b1d0550"]])

export default __exports__